module.exports = __webpack_public_path__ + "img/arrow_up.1280503b.svg";